import React, { Component } from "react";
import { Helmet } from "react-helmet";
import Breadcrumb from "../../common/breadcrumb";
import {
  loadUserDetailsFromLocalStorage,
  getValueFromLanguageObject,
  getCurrencySymbol,
  getColorCodeBasedOnKey,
  getCurrentLanguage,
  formatPrice,
} from "../../../store";
import {
  customPostCall,
  getCall,
  getDownloadPDF,
  patchCall,
  postCall,
} from "../../../api/post";
import {
  getMerchantInformationUrl,
  getSettingUrl,
  getOrderStatusUrl,
  getMasterDetailsIdUrl,
  getSadadPaymentChecksumUrl,
  getPaymentDetailsUrl,
  getDownloadInvoiceUrl,
} from "../../../services";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import Moment from "react-moment";
import OrderFilterBar from "../../collection/common/order-filter-bar";
import InfiniteScroll from "react-infinite-scroll-component";
import { getNotificationCounter, getCommonCounter } from "../../../actions";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import MainLoader from "../../../animation/MainLoader";
import ErrorMessageAnimationModal from "../../../animation/ErrorMessageAnimationModal";
import CancelOrderAnim from "../../../animation/CancelOrderAnim";
import NoProductFoundOrderAnim from "../../../animation/AnimFiles/NoProductFoundOrderAnim";
import ConfirmAlertPopup from "../../../Alert/ConfirmAlertPopup";
import SuccessMessageAnimationModal from "../../../animation/SuccessMessageAnimationModal";
import { isInquiryOrCart } from "../../../actions";
import {
  clearLocalStorageReload,
  getCurrentDate,
  isOpenStoreIdExist,
  navigateTo,
  removeUserDetailAndOtherDetails,
} from "../../../utils/utils";
import { sadadPaymentConfigure } from "../../checkout/sadad_config";
import OrderPaymentOptionModal from "../sadadpaymentsample/OrderPaymentOptionModal";
import { payment } from "../../../api/payment";
import SadadPaymentSample from "../sadadpaymentsample/SadadPaymentSample";
import PaypalExpressBtn from "react-paypal-express-checkout";
import { GooglePayConfigure } from "../../checkout/goople_pay_config";
import GooglePayButton from "@google-pay/button-react";
import { paytmConfigure } from "../../checkout/paytm_config";
import { CheckoutProvider, Checkout } from "paytm-blink-checkout-react";
import download from "downloadjs";

const SSR_SIMULATE = "SSR Simulate : ";
class Orders extends Component {
  state = {
    layoutColumns: 3,
    productList: [],
    newArrival: [],
    skip: 0,
    orderList: [],
    orderStatusList: [],
    orderStatusFilter: "0",
    paymentStatusFilter: "0",
    sortingFilter: "0",
    hasMoreItems: true,
    limit: 20,
    isLoading: true,
    AppTitle: "",
    currentCatelogueType: {},
    merchantInfo: {},
    showErrorMessageModal: false,
    errorMessage: "",
    showSuccessMessageModal: false,
    successMessage: "",
    masterDetailsObj: {},
    isInquiryState: false,
    sadadPaymentConfig: {},
    sadadPaymentChecksum: "",
    isOpenPayWithSadad: false,
    paymentMethod: "Cash On Delivery",
    orderIndex: 0,
    payUMoneyConfig: {},
    payPalConfig: {},
    googlePayConfig: {},
    paytmConfig: {},
    isHidePaymentButton: true,
  };

  componentDidMount() {
    const userDetails = loadUserDetailsFromLocalStorage();
    if (!isOpenStoreIdExist() && userDetails === undefined) {
      navigateTo(this.props, `/login`);
      return;
    }
    if (isOpenStoreIdExist()) {
      navigateTo(this.props, `/`);
      return;
    }

    this.initMasterDetailsId().then(() => {
      const { masterDetailsObj } = this.state;
      this.props.isInquiryOrCart(masterDetailsObj);
      this.initIsInquiry().then(() => {
        this.initOrderList().then(() => {
          this.setState({ isLoading: false });
        });
      });
      this.fetchMoreItems();
      this.initMerchantInfo();
      this.initCatelogueSettings();
      this.initOrderStatus();
      this.initPaymentDetails();
      this.props.notificationCounter();
    });
  }

  getOrderId(orderItem) {
    const { id = "" } = orderItem || {};
    return id;
  }

  getTotalProductItems = () => {
    let totalProductItems = "";
    const { orderList } = this.state;
    if (orderList.length > 0) {
      const [orderdetail] = orderList;
      const { totalitems = "" } = orderdetail || {};
      totalProductItems = totalitems;
    }
    return totalProductItems;
  };

  initPaymentDetails = async () => {
    const { masterDetailsObj } = this.state;
    const paymentDetailsUrl = getPaymentDetailsUrl(masterDetailsObj);
    const paymentDetails = await getCall(paymentDetailsUrl, []);
    if (paymentDetails.error) {
      clearLocalStorageReload({ response: paymentDetails });
      this.loadErrorMessageAnimation(paymentDetails.error.message);
    } else {
      this.setState({ paymentDetails });
    }
  };

  payWithSadad = async () => {
    const { paymentDetails, orderItem } = this.state;
    const { id: orderId = "" } = orderItem || {};
    const {
      id: userId,
      email: userEmail,
      cellnumber: userCellnumber,
    } = loadUserDetailsFromLocalStorage();
    const paytmPaymentMethodDetails = paymentDetails[0].text.filter(
      (paymentMethods) => {
        return paymentMethods.name === "Sadad";
      }
    );
    const merchantId = paytmPaymentMethodDetails[0].config.MERCHANT_ID;
    const secretKey = paytmPaymentMethodDetails[0].config.MERCHANT_KEY;

    const sadadPaymentWebsite = process.env.SADAD_WEBSITE_URL;
    const subTotal = this.getSubTotalFromTotalandServiceCharges(orderItem);
    const totalAmount = parseFloat(
      this.getGrandTotal(
        subTotal,
        this.getCGSTFromTotal(subTotal),
        this.getSGSTFromTotal(subTotal),
        this.getIGSTFromTotal(subTotal),
        orderItem.shippingprice
      )
    );
    const currentUrl = window.location.href;
    const callbackPageUrl = currentUrl.substring(
      0,
      currentUrl.lastIndexOf("/")
    );
    const sadadCallbackUrl = process.env.SADAD_CALLBACK_URL;
    const transactionDate = getCurrentDate();
    const sadadPageLanguage = getCurrentLanguage();
    const totalProductItems = this.getTotalProductItems(orderItem);
    const productionDetails = [
      {
        order_id: orderId,
        itemname: "Product",
        amount: totalAmount.toFixed(2),
        quantity: totalProductItems.toString(),
        // type: "line_item",
      },
    ];
    const sadadCheckoutVersion = process.env.SADAD_CHECKOUT_VERSION;
    const checksumObj = sadadPaymentConfigure({
      merchantId,
      orderId,
      sadadPaymentWebsite,
      totalAmount: totalAmount.toFixed(2),
      userId,
      userEmail,
      userCellnumber,
      sadadPageLanguage,
      sadadCallbackUrl,
      transactionDate,
      productionDetails,
      sadadCheckoutVersion,
    });
    const sadadPaymentChecksumUrl = getSadadPaymentChecksumUrl();
    const checksumResponse = await customPostCall(
      sadadPaymentChecksumUrl,
      checksumObj,
      secretKey
    );
    this.setState({ sadadPaymentConfig: checksumObj }, () => {
      this.setState({ sadadPaymentChecksum: checksumResponse.checksum }, () => {
        this.setState({ isOpenPayWithSadad: true }, () => {
          const orderPaymentForm = document.getElementById("orderPaymentForm");
          // console.log("orderPaymentForm");
          // console.log(orderPaymentForm);
          orderPaymentForm.submit();
        });
      });
    });
  };

  initMasterDetailsId = async () => {
    let masterDetailsObj = {};
    const publicUrl = window.location.pathname.split("/")[1];
    const masterDetailsIdUrl = getMasterDetailsIdUrl(publicUrl);
    const masterDetails = await getCall(masterDetailsIdUrl, []).then();
    if (masterDetails.error) {
      clearLocalStorageReload({ response: masterDetails });
    } else {
      if (masterDetails) {
        masterDetailsObj = masterDetails;
      }
    }
    this.setState({ masterDetailsObj: masterDetailsObj });
  };

  initMerchantInfo = async () => {
    const { masterDetailsObj } = this.state;
    const merchantInfoUrl = getMerchantInformationUrl(masterDetailsObj);
    const merchantInfo = await getCall(merchantInfoUrl, []);
    if (merchantInfo.error) {
      clearLocalStorageReload({ response: merchantInfo });
      this.setState({
        isMerchantGSTEnable: false,
        merchantInfo: {},
        AppTitle: "",
      });
    } else {
      this.setState({
        merchantInfo,
        AppTitle: merchantInfo.companyname,
        isMerchantGSTEnable: merchantInfo.enablegst === 0 ? false : true,
      });
    }
  };

  initCatelogueSettings = async () => {
    const { masterDetailsObj } = this.state;
    const settingUrl = getSettingUrl(masterDetailsObj);
    const settingInfo = await getCall(settingUrl, []);
    if (settingInfo.error) {
      clearLocalStorageReload({ response: settingInfo });
    } else {
      let settings = {};
      settingInfo.forEach((setting) => {
        if (
          (setting.registerallow === "Catalogue_FMCG" ||
            setting.registerallow === "Catalogue_Jewellary" ||
            setting.registerallow === "Catalogue_Electronics" ||
            setting.registerallow === "Catalogue_FABRIC") &&
          setting.status === 1
        ) {
          settings = setting;
        }
      });
      this.setState({ currentCatelogueType: settings });
    }
  };

  // Get Inquiry Or Cart Setting
  initIsInquiry = async () => {
    const { masterDetailsObj } = this.state;
    let isInquiry = false;
    const settingUrl = getSettingUrl(masterDetailsObj);
    const setting = await getCall(settingUrl, []);
    if (setting.error) {
      clearLocalStorageReload({ response: setting });
    } else {
      for (let i = 0; i < setting.length; i++) {
        if (setting[i].registerallow === "IS_INQUIRY") {
          if (setting[i].status === 1) {
            isInquiry = true;
          }
        }
      }
    }
    this.setState({ isInquiryState: isInquiry });
  };

  initOrderList = async () => {
    const {
      orderStatusFilter,
      paymentStatusFilter,
      skip,
      sortingFilter,
      orderList,
      limit,
      isInquiryState,
    } = this.state;
    const { isInquiry } = this.props;
    const userDetails = loadUserDetailsFromLocalStorage();
    if (userDetails === undefined) {
      navigateTo(this.props, `/login`);
      return;
    }
    const { id } = userDetails;
    let orderListUrl = `orders?filter[where][userId]=${id}&filter[where][inshoppingcart]=${
      isInquiryState ? 2 : 0
    }&filter[include]=orderdetails`;

    if (orderStatusFilter !== "0") {
      orderListUrl =
        orderListUrl + "&filter[where][orderstatus]=" + orderStatusFilter;
    }
    if (paymentStatusFilter !== "0") {
      orderListUrl =
        orderListUrl + "&filter[where][paymentstatus]=" + paymentStatusFilter;
    }

    if (sortingFilter !== "0") {
      if (sortingFilter === "1") {
        // Price: High to Low
        orderListUrl = orderListUrl + "&filter[order][1]=totalamount DESC";
      }
      if (sortingFilter === "2") {
        // Price: Low to High
        orderListUrl = orderListUrl + "&filter[order][1]=totalamount ASC";
      }
      if (sortingFilter === "3") {
        // Date: New to Old
        orderListUrl = orderListUrl + "&filter[order][1]=date DESC";
      }
      if (sortingFilter === "4") {
        // Price: Old to New
        orderListUrl = orderListUrl + "&filter[order][1]=date ASC";
      }
    } else {
      orderListUrl = orderListUrl + "&filter[order]=created DESC";
    }
    orderListUrl = orderListUrl + `&filter[skip]=${skip}&filter[limit]=20`;

    const orders = await getCall(orderListUrl, []);
    if (orders.error) {
      clearLocalStorageReload({ response: orders });
      this.loadErrorMessageAnimation(orders.error.message);
      if (orders.error.statusCode === 401) {
        removeUserDetailAndOtherDetails();
        navigateTo(this.props, `/login`);
        return;
      }
    } else {
      if (skip > 0) {
        const pl = orderList.concat(orders);
        if (orders.length < limit || orders.length === 0) {
          this.setState({ hasMoreItems: false });
        } else {
          this.setState({ hasMoreItems: true });
        }
        this.setState({ orderList: pl });
      } else {
        if (orders.length < limit || orders.length === 0) {
          this.setState({ hasMoreItems: false });
        } else {
          this.setState({ hasMoreItems: true });
        }
        this.setState({ orderList: orders });
      }
    }
  };

  initOrderStatus = async () => {
    const { masterDetailsObj } = this.state;
    const orderStatusUrl = getOrderStatusUrl(masterDetailsObj);
    const orderStatusList = await getCall(orderStatusUrl, []);
    if (orderStatusList.error) {
      clearLocalStorageReload({ response: orderStatusList });
      this.loadErrorMessageAnimation(orderStatusList.error.message);
      if (orderStatusList.error.statusCode === 401) {
        removeUserDetailAndOtherDetails();
        navigateTo(this.props, `/login`);
        return;
      }
    } else {
      this.setState({ orderStatusList });
    }
  };

  downloadInvoice = async (orderItem) => {
    const { orderId, ordermedia } = orderItem || {};
    const { masterDetailsObj } = this.state || {};
    const downloadInvoiceUrl = getDownloadInvoiceUrl(
      masterDetailsObj,
      ordermedia
    );
    download(downloadInvoiceUrl);
    // const downloadInvoiceRepsonse = await getDownloadPDF(downloadInvoiceUrl, {
    //   id,
    // });
    // const { error } = downloadInvoiceRepsonse || {};
    // if (error) {
    //   clearLocalStorageReload({ response: downloadInvoiceRepsonse });
    // } else {
    // }
  };

  handleOrderStatusChange = (orderstatus) => {
    this.setState(
      {
        orderStatusFilter: orderstatus,
        skip: 0,
        hasMoreItems: true,
        // isLoading: true,
      },
      () => {
        this.initOrderList().then(() => {
          this.setState({ isLoading: false });
        });
      }
    );
  };

  handlePaymentStatusChange = (paymentstatus) => {
    // console.log("handlePaymentStatusChange");
    // console.log(paymentstatus);
    this.setState(
      {
        paymentStatusFilter: paymentstatus,
        skip: 0,
        hasMoreItems: true,
        isLoading: true,
      },
      () => {
        this.initOrderList().then(() => {
          this.setState({ isLoading: false });
        });
      }
    );
  };

  handleSortingOrderFilter = (sort) => {
    this.setState(
      { sortingFilter: sort, skip: 0, hasMoreItems: true, isLoading: true },
      () => {
        this.initOrderList().then(() => {
          this.setState({ isLoading: false });
        });
      }
    );
  };

  // onClickOfViewOrder = (order, index) => {
  //     return (<Link to={`/ordersummary/${order.id}`}></Link>);
  // }

  onClickOfCancelOrder = (order, index) => {
    const { isInquiry } = this.props;
    confirmAlert({
      customUI: ({ onClose }) => {
        const submitClick = (props) => {
          this.setState({ isLoading: true }, () => {
            this.cancelOrder(order, index).then(() => {
              this.setState({ isLoading: false });
            });
            onClose();
          });
        };
        return (
          <>
            <ConfirmAlertPopup
              title={
                !isInquiry
                  ? getValueFromLanguageObject("str_cancel_order")
                    ? getValueFromLanguageObject("str_cancel_order")
                    : "Cancel Order"
                  : getValueFromLanguageObject("str_cancel_inquiry")
                  ? getValueFromLanguageObject("str_cancel_inquiry")
                  : "Cancel Inquiry"
              }
              message={
                isInquiry
                  ? getValueFromLanguageObject(
                      "str_are_you_sure_you_want_to_cancel_inquiry"
                    )
                    ? getValueFromLanguageObject(
                        "str_are_you_sure_you_want_to_cancel_inquiry"
                      )
                    : "Are you sure you want to cancel inquiry"
                  : getValueFromLanguageObject(
                      "str_are_you_sure_you_want_to_cancel_order"
                    )
                  ? getValueFromLanguageObject(
                      "str_are_you_sure_you_want_to_cancel_order"
                    )
                  : "Are you sure you want to cancel order"
              }
              animation={<CancelOrderAnim />}
              submit={
                getValueFromLanguageObject("str_yes_cancel_it")
                  ? getValueFromLanguageObject("str_yes_cancel_it")
                  : "Yes, Cancel it!"
              }
              submitClick={submitClick}
              cancelClick={onClose}
              cancel={
                getValueFromLanguageObject("str_no")
                  ? getValueFromLanguageObject("str_no")
                  : "No"
              }
            />
          </>
        );
      },
    });
  };

  cancelOrder = async (order, index) => {
    const { isInquiry } = this.props;
    const cancelOrderUrl = `orders/cancelOrder`;
    const cancelOrderObj = {
      orderstatus: 5,
      orderId: order.id,
    };

    const cancelOrder = await patchCall(cancelOrderUrl, cancelOrderObj);
    if (cancelOrder.error) {
      clearLocalStorageReload({ response: cancelOrder });
      this.loadErrorMessageAnimation(cancelOrder.error.message);
      if (cancelOrder.error.statusCode === 401) {
        removeUserDetailAndOtherDetails();
        navigateTo(this.props, `/login`);
        return;
      }
    } else {
      if (isInquiry) {
        this.loadSuccessMessageAnimation(
          getValueFromLanguageObject("msg_your_inquiry_is_successfully_cancel")
            ? getValueFromLanguageObject(
                "msg_your_inquiry_is_successfully_cancel"
              )
            : "Your inquiry is successfully cancelled"
        );
      } else {
        this.loadSuccessMessageAnimation(
          getValueFromLanguageObject("msg_your_order_is_successfully_cancel")
            ? getValueFromLanguageObject(
                "msg_your_order_is_successfully_cancel"
              )
            : "Your order is successfully cancelled"
        );
      }

      this.initOrderList();
      // orderList[index].orderstatus = 5;
      // this.setState({ orderList });
    }
  };

  renderOrderStatus(orderstatus) {
    const statusMap = {
      1: "Pending",
      2: "In Process",
      3: "In Process",
      4: "Delivered",
      5: "Completed",
      6: "Rejected",
      7: "Cancelled",
      8: "On Hold",
      9: "Cancelled - Points Reversed",
      10: "Failed",
      11: "Refunded",
      12: "Reversed",
      13: "Chargeback",
      14: "Expired",
      15: "Processed",
      16: "Voided",
      17: "Out of Stock",
      18: "Client Revert Pending",
      19: "Partially Complete",
      20: "Redeemed",
      21: "Partial Cancel - Points Back",
      22: "Partially Refunded",
    };

    const status = statusMap[orderstatus] || "";

    // Map labels to the six existing CSS classes only
    const statusClassMap = {
      "Pending": "order-status-pending",
      "In Process": "order-status-inprogress",
      "Delivered": "order-status-delivered",
      "Completed": "order-status-confirmed",
      "Rejected": "order-status-rejected",
      "Cancelled": "order-status-cancelled",
      "On Hold": "order-status-pending",
      "Cancelled - Points Reversed": "order-status-cancelled",
      "Failed": "order-status-rejected",
      "Refunded": "order-status-confirmed",
      "Reversed": "order-status-confirmed",
      "Chargeback": "order-status-rejected",
      "Expired": "order-status-rejected",
      "Processed": "order-status-confirmed",
      "Voided": "order-status-rejected",
      "Out of Stock": "order-status-rejected",
      "Client Revert Pending": "order-status-pending",
      "Partially Complete": "order-status-inprogress",
      "Redeemed": "order-status-confirmed",
      "Partial Cancel - Points Back": "order-status-cancelled",
      "Partially Refunded": "order-status-confirmed",
    };

    const orderStatusClass = statusClassMap[status] || "order-status-default";

    return (
      <span className={`${orderStatusClass} order-status-color`}>
        {status}
      </span>
    );
  }

  renderPaymentStatus(paymentstatus) {
    if (paymentstatus === 1) {
      return (
        <span className={`order-status-pending order-status-color`}>
          PENDING
        </span>
      );
    } else if (paymentstatus === 2) {
      return (
        <span className={`order-status-confirmed order-status-color`}>
          SUCCESS
        </span>
      );
    } else {
      return (
        <span className={`order-status-rejected order-status-color`}>
          FAILED
        </span>
      );
    }
  }

  LayoutViewClicked(colums) {
    this.setState({
      layoutColumns: colums,
    });
  }

  fetchMoreItems = () => {
    const { orderList } = this.state;
    this.handlePagination(orderList.length);
  };

  handlePagination = (skip) => {
    this.setState({ skip }, () => {
      this.initOrderList();
    });
  };

  getTotalofCart(orderList) {
    let total = 0;
    const { orderdetail } = orderList || {};
    if (orderdetail)
      for (let i = 0; i < orderdetail.length; i++) {
        total = total + orderdetail[i].amount * orderdetail[i].quantity;
      }

    return total;
  }

  getSubTotalFromTotalandServiceCharges = (orderItem) => {
    let subTotal = 0;
    const total = this.getTotalofCart(orderItem);
    const serviceChargeAmount = this.renderServiceCharges(orderItem);
    subTotal = total + parseFloat(serviceChargeAmount);
    return subTotal;
  };

  getCGSTFromTotal = (total) => {
    const { merchantInfo } = this.state;
    return (total * merchantInfo.CGST) / 100;
  };
  getSGSTFromTotal = (total) => {
    const { merchantInfo } = this.state;
    return (total * merchantInfo.SGST) / 100;
  };

  getIGSTFromTotal = (total) => {
    const { merchantInfo } = this.state;
    return (total * merchantInfo.IGST) / 100;
  };

  getGrandTotal = (total, cgst, sgst, igst, shippingCharge) => {
    const { merchantInfo, currentCatelogueType } = this.state;
    var grandTotal = 0;
    if (merchantInfo.enablegst === 0) {
      grandTotal = total + shippingCharge;
      return grandTotal;
    }
    if (
      merchantInfo.enablegst === 1 &&
      currentCatelogueType &&
      currentCatelogueType.registerallow === "Catalogue_Jewellary"
    ) {
      grandTotal = total + shippingCharge;
      return grandTotal;
    }
    if (merchantInfo.countryname === "India") {
      grandTotal = total + cgst + sgst + shippingCharge;
    } else {
      grandTotal = total + igst + shippingCharge;
    }
    return grandTotal;
  };

  renderServiceCharges = (orderItem) => {
    let serviceCharges = 0;
    const { additionalchargedetails } = orderItem || {};
    if (additionalchargedetails) {
      const additionalchargedetailsObj =
        JSON.parse(additionalchargedetails) || {};
      const { charges = 0 } = additionalchargedetailsObj || {};
      serviceCharges = formatPrice(charges);
    }
    return serviceCharges;
  };

  renderOrderCancelIcon = (item, index) => {
    const { orderStatusList } = this.state;
    return (
      <>
        {orderStatusList.map((statusItem) => {
          return statusItem.id === item.orderstatus &&
            (statusItem.status === "pending" ||
              statusItem.status === "PENDING") ? (
            <div
              className="icon"
              data-toggle="tooltip"
              data-placement="bottom"
              title="Cancel Order"
            >
              <a href onClick={() => this.onClickOfCancelOrder(item, index)}>
                <i className="fa fa-times" />
              </a>
            </div>
          ) : (
            <></>
          );
        })}
      </>
    );
  };

  renderPaymentButton = (item, index) => {
    const {
      sadadPaymentConfig,
      sadadPaymentChecksum,
      isOpenPayWithSadad,
      orderIndex,
      isHidePaymentButton,
      paymentMethod,
      orderStatusList,
    } = this.state;
    const strPayNow = getValueFromLanguageObject("str_pay_now")
      ? getValueFromLanguageObject("str_pay_now")
      : "Pay now";

    return (
      <>
        {item.paymentstatus !== 2 && isHidePaymentButton && (
          <td>
            <div className="payNow-record">
              <button
                className="btn btn-solid"
                onClick={() => {
                  this.setState({
                    isEditPaymentOptionModalVisible: true,
                    orderIndex: index,
                  });
                }}
              >
                {strPayNow}
              </button>
            </div>
            {/* <SadadPaymentSample
              sadadPaymentConfig={sadadPaymentConfig}
              sadadPaymentChecksum={sadadPaymentChecksum}
              isOpenPayWithSadad={isOpenPayWithSadad}
              button={strPayNow}
              payWithSadad={() => this.payWithSadad()}
            /> */}
          </td>
        )
        // : (
        //   <td>
        //     {" "}
        //     {/* {paymentMethod === "Paypal" &&
        //       this.state.payPalConfig &&
        //       this.state.payPalConfig.env && (
        //         <PaypalExpressBtn
        //           env={this.state.payPalConfig.env}
        //           client={this.state.payPalConfig.client}
        //           currency={this.state.payPalConfig.currency}
        //           total={this.state.payPalConfig.total}
        //           onError={this.onErrorOfPaypalPayment}
        //           onSuccess={this.onSuccessOfPaypalPayment}
        //           onCancel={this.onCancelOfPaypalPayment}
        //           shipping={1}
        //           style={{
        //             color: "gold",
        //             shape: "rect",
        //             size: "large",
        //             label: "pay",
        //           }}
        //         />
        //       )} */}
        //     {/* {paymentMethod === "GooglePay" && (
        //       <GooglePayButton
        //         environment="PRODUCTION" // TEST, PRODUCTION
        //         buttonType="long"
        //         style={{ marginTop: "10px" }}
        //         paymentRequest={this.state.googlePayConfig}
        //         onLoadPaymentData={this.makeGooglePayPayment}
        //         onCancel={(cancel) => {
        //           console.log("cancel");
        //           console.log(cancel);
        //           this.loadErrorMessageAnimation("Payment failed");
        //           this.setState({ paymentResponse: cancel }, () => {
        //             this.updatePaymentStatusGooglePay(3);
        //             this.setState({
        //               isEditPaymentOptionModalVisible: false,
        //             });
        //           });
        //         }}
        //         onError={(error) => {
        //           console.log("error");
        //           console.log(error);
        //           this.loadErrorMessageAnimation("Payment failed");
        //           this.setState({ paymentResponse: error }, () => {
        //             this.updatePaymentStatusGooglePay(3);
        //             this.setState({
        //               isEditPaymentOptionModalVisible: false,
        //             });
        //           });
        //         }}
        //         onReadyToPayChange={(change) => {
        //           console.log("change");
        //           console.log(change);
        //         }}
        //         // onPaymentAuthorized={(auth) => {
        //         //   console.log("auth");
        //         //   console.log(auth);
        //         // }}
        //         // onPaymentDataChanged={(dataChange) => {
        //         //   console.log("dataChange");
        //         //   console.log(dataChange);
        //         // }}
        //       />
        //     )} */}
        //   </td>
        // )
        }
      </>
    );
  };

  loadErrorMessageAnimation = (message) => {
    this.setState({ errorMessage: message, showErrorMessageModal: true });
  };
  loadSuccessMessageAnimation = (message) => {
    this.setState({ successMessage: message, showSuccessMessageModal: true });
  };

  renderOrderTableTab = () => {
    const strOrderNo = "Order No";
    const strDate = "Date";
    const strItems = "Items";
    const strOrderStatus = "Order Status";
    const strTotal = "Total Points";
    const strAction = "Action";

    return (
      <thead>
        <tr className="table-head">
          <th scope="col" className="pb-1 pt-1">
            {strOrderNo}
          </th>
          <th scope="col" className="pb-1 pt-1">
            {strDate}
          </th>
          <th scope="col" className="pb-1 pt-1">
            {strItems}
          </th>
          <th scope="col" className="pb-1 pt-1">
            {strOrderStatus}
          </th>
          <th scope="col" className="pb-1 pt-1">
            {strTotal}
          </th>
          <th scope="col" className="pb-1 pt-1">
            {strAction}
          </th>
        </tr>
      </thead>
    );
  };

  // Add this method inside your Orders class
  renderGrandTotal = (orderItem) => {
    const orderdetails = orderItem.orderdetails || [];
    let total = 0;
    for (let i = 0; i < orderdetails.length; i++) {
      total += orderdetails[i].amount * orderdetails[i].quantity;
    }
    const shippingCharge = orderItem.shippingprice || 0;
    // Show "POINTS" only once after the amount, with a space
    return `${formatPrice(total + shippingCharge)}`;
  };

  render() {
    const { symbol } = this.props;
    const {
      orderList,
      orderStatusList,
      hasMoreItems,
      isLoading,
      AppTitle,
      showErrorMessageModal,
      errorMessage,
      showSuccessMessageModal,
      successMessage,
      isEditPaymentOptionModalVisible,
      paymentDetails,
      paymentMethod,
      isHidePaymentButton,
    } = this.state;

    return (
      <div>
        <Helmet>
          <title>
            {AppTitle} |{" "}
            {this.props.isInquiry
              ? getValueFromLanguageObject("str_inquiry_page")
                ? getValueFromLanguageObject("str_inquiry_page")
                : "Inquiry Page"
              : getValueFromLanguageObject("str_order_page")
              ? getValueFromLanguageObject("str_order_page")
              : "Order Page"}
          </title>
          <meta
            name="description"
            content="Multikart – Multipurpose eCommerce React Template is a multi-use React template. It is designed to go well with multi-purpose websites. Multikart Bootstrap 4 Template will help you run multiple businesses."
          />
        </Helmet>
        {this.props.isInquiry ? (
          <Breadcrumb
            title={
              getValueFromLanguageObject("str_inquiry")
                ? getValueFromLanguageObject("str_inquiry")
                : "Inquiry"
            }
          />
        ) : (
          <Breadcrumb
            title={
              getValueFromLanguageObject("str_orders")
                ? getValueFromLanguageObject("str_orders")
                : "Orders"
            }
          />
        )}

        <section className="cart-section section-b-space">
          <div className="container">
            <div className="collection-product-wrapper order-page-filter">
              <div className="product-top-filter">
                <div className="container-fluid p-0">
                  {/* <div className="row">
                                        <div className="col-xl-12">
                                            <div className="filter-main-btn">
                                                <span onClick={this.openFilter}
                                                    className="filter-btn btn btn-theme"><i
                                                        className="fa fa-filter"
                                                        aria-hidden="true"></i> Filter</span>
                                            </div>
                                        </div>
                                    </div> */}
                  <div className="row">
                    <div className="col-12 ">
                      <OrderFilterBar
                        orderList={orderList}
                        orderStatusList={orderStatusList}
                        handleOrderStatusChange={this.handleOrderStatusChange}
                        handlePaymentStatusChange={
                          this.handlePaymentStatusChange
                        }
                        handleSortingOrderFilter={this.handleSortingOrderFilter}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <InfiniteScroll
              dataLength={orderList.length} //This is important field to render the next data
              next={this.fetchMoreItems}
              hasMore={hasMoreItems}
              loader={<div className="loading-cls" />}
              // endMessage={
              //     <p className="seen-cls seen-it-cls">
              //         <b>Yay! You have seen it all</b>
              //     </p>
              // }
            >
              <div className="container">
                <div className="row">
                  <div className="col-sm-12 p-0">
                    <div className="table-responsive">
                      
                      <table className="table cart-table table-responsive-xs">
                        {this.renderOrderTableTab()}
                        {orderList.length === 0 ? (
                          <tbody>
                            <tr>
                              <td colSpan="6" className="text-center">
                                No orders data found
                              </td>
                            </tr>
                          </tbody>
                        ) : (
                          orderList.map((item, index) => (
                            <tbody key={index}>
                              <tr>
                                <td>
                                  <Link to={`/ordersummary/${item.id}`}>
                                  {item.orderno}
                                </Link>
                              </td>
                              <td>
                                <Moment format="DD-MMM-YYYY">
                                  {item.date}
                                </Moment>
                              </td>
                              <td>
                                <div className="qty-box">
                                  {item.orderdetails
                                    ? item.orderdetails.length
                                    : 0}
                                </div>
                              </td>
                              <td>
                                {
                                  console.log("item.orderstatus", item.orderstatus) || null
                                }
                                {this.renderOrderStatus(item.orderstatus)}
                              </td>
                              <td>
                                <div className="td-color">
                                  {this.renderGrandTotal(item)}
                                </div>
                              </td>
                              <td>
                                <div
                                  className="icon"
                                  data-toggle="tooltip"
                                  data-placement="bottom"
                                  title="View Order"
                                >
                                  <Link to={`/ordersummary/${item.id}`}>
                                    <i className="fa fa-eye" />
                                  </Link>
                                </div>
                                {item && item.ordermedia && (
                                  <div
                                    className="icon"
                                    data-toggle="tooltip"
                                    data-placement="bottom"
                                    title="Download Invoice"
                                    onClick={() => {
                                      this.downloadInvoice(item);
                                    }}
                                  >
                                    <i
                                      className="fa fa-file-text-o"
                                      aria-hidden="true"
                                    />
                                  </div>
                                )}
                                {item.orderstatus &&
                                  this.renderOrderCancelIcon(item, index)}
                              </td>
                            </tr>
                            {/* ...Payment modal and other UI... */}
                          </tbody>
                        ))
                      )}
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </InfiniteScroll>
          </div>
          {/* ...Paytm, loaders, error/success modals... */}
        </section>
        {/* ...NoProductFoundOrderAnim, loaders, modals... */}
      </div>
    );
  }
}

// export default Orders;
const mapStateToProps = (state) => ({
  symbol: getCurrencySymbol(),
  isInquiry: state.settings.isInquiry,
});

export default connect(mapStateToProps, {
  isInquiryOrCart: isInquiryOrCart,
  counter: getCommonCounter,
  notificationCounter: getNotificationCounter,
})(withRouter(Orders));
